import { Col } from 'react-bootstrap';

export function QuestionExtraInformation({
  title,
  headerColor,
  backgroundColor,
  body,
}) {
  return (
    <Col md={12}>
      <div
        className="mt-2 questionExtraInformationTitle"
        style={{ backgroundColor: headerColor }}
      >
        <span className="title" style={{ color: '#2c2c2c' }}>
          {title}
        </span>
      </div>
      <div
        className="questionExtraInformationBody text"
        style={{ backgroundColor, borderColor: headerColor, overflow: 'wrap' }}
      >
        {body}
      </div>
    </Col>
  );
}
